<table class="basicTable">
  <thead>
  <tr>
    <th colspan="100">{{title}}</th>
  </tr>
  </thead>
  <tbody>
  <tr>
    <td>
      <div *ngIf="isEmpty && emptyText" class="empty-text">{{emptyText}}</div>
      <div *ngIf="values && !isEmpty" class="value-list" [attr.aria-label]="title">
        <div *ngIf="itemHeader || valueHeader" class="value-row value-header">
          <span>{{itemHeader}}</span>
          <span>{{valueHeader}}</span>
        </div>
        <div *ngFor="let item of items" class="value-row">
          <label>{{getValue(item)}}</label>
          <input [ngModel]="getItemValue(item)"
                 (ngModelChange)="setItemValue(item, $event)"
                 [ngModelOptions]="{standalone: true}"
                 [attr.aria-label]="getValue(item) + ' value'">
        </div>
      </div>
      <select *ngIf="!values" [size]="listSize" [attr.aria-label]="title">
        <option *ngFor="let item of items" [value]="getValue(item)">{{getValue(item)}}</option>
      </select>
    </td>
  </tr>
  </tbody>
</table>
